$(function () {
  import(
    /* webpackChunkName: "chunk.owl-carousel" */ "owl.carousel/src/js/owl.carousel"
  ).then(() => {
    import(
      /* webpackChunkName: "chunk.owl-carousel-navigation" */ "owl.carousel/src/js/owl.navigation"
    ).then(() => {
      $(".js-slider-video").owlCarousel({
        responsive: {
          0: {
            items: 1,
            dots: false,
          },
          768: {
            items: 1,
            dots: true,
          },
        },
        loop: true,
        nav: true,
        dotsEach: true,
        margin: 20,
        smartSpeed: 200,
      });

      $(".js-slider-video").on("change.owl.carousel", function (event) {
        let slider = document.getElementById("js-about-us-slider");
        let sliderItems = slider.querySelectorAll(".owl-item");
        sliderItems.forEach(function (sliderItem) {
          let iframe = sliderItem.querySelector("iframe.video-media");
          if (iframe) {
            let re = /autoplay=1/gi;
            let iframeURL = iframe.src;
            let iframeNewURL = iframeURL.replace(re, "autoplay=0");
            iframe.src = iframeNewURL;
          }
        });
      });
    });
  });
});
